import Api from './Api';

class TipoResinaService {
  constructor() {
    this.$api = Api;
  }

  async findAll(filters) {
    return this.$api.get('/tipos-resina', filters);
  }

  async save(data) {
    const id = data.id || 0;

    if (id === 0) {
      return this.$api.post('/tipo-resina', data);
    }

    return this.$api.put(`/tipo-resina/${id}`, data);
  }

  async findById(id) {
    return this.$api.get(`/tipo-resina/${id}`);
  }

  async remove(id) {
    return this.$api.delete(`/tipo-resina/${id}`);
  }
}

export default new TipoResinaService();
